// axios
import axios from 'axios'

// const baseURL = 'http://localhost:8098' // local sgnode api instance
const baseURL = 'http://18.191.180.73:8085' // production
const config = {}

export default axios.create({
  baseURL,
  config // You can add your headers here
})
